import AppIcon from "components/common/appIcon/AppIcon"
import { MoveDown, MoveUp, Users } from "lucide-react"
import { cn } from "@/utils/shadcn-utils"

export type StatisticCardProps = {
  total: string | number
  title: string
  percentage?: number
  icon:  JSX.Element
}

const StatisticCard = ({ total, title, icon }: StatisticCardProps) => {
  // <div className="rounded-lg bg-white shadow-sm px-5 lg:px-7 py-2 lg:py-4">
  //   <div className="flex justify-between">
  //     <p className="font-bold text-2xl lg:text-4xl text-blue-700">
  //       {total}
  //     </p>
  //     <div className="">
  //       <p className="bg-green-100 p-1 rounded text-gray-500 text-xs">
  //         +{quantity}
  //       </p>
  //     </div>
  //   </div>
  //   <p className="text-gray-500 text-sm md:text-md xl:text-lg">
  //     {title}
  //   </p>
  // </div>
  return (
    <div className="flex justify-between rounded-xl bg-white shadow-sm px-4 py-5 lg:py-8 relative">
      <div className='space-y-4'>
        <p className="text-gray2 text-sm">{title}</p>
        <p className="text-2xl font-bold">{total}</p>
      </div>

      {/*{ percentage &&*/}
      {/*  <p className={cn( "flex gap-1 items-center" ,*/}
      {/*    percentage > 0 ? "text-greenText" : "text-red1"*/}
      {/*  )}>*/}
      {/*    {*/}
      {/*      percentage > 0 ? <span className="flex items-center"> <MoveUp className=" h-3" /> + </span> :*/}
      {/*      percentage === 0 ? ""*/}
      {/*        : <span className="flex items-center"> <MoveDown className="h-3" /> - </span>*/}
      {/*    }*/}
      {/*    {Math.abs(percentage)}% ce mois*/}
      {/*  </p>*/}
      {/*}*/}
      <div className="">
        <AppIcon>
          {icon}
        </AppIcon>
      </div>
    </div>
  )
}

export default StatisticCard
